import createTableStore from "ds/components/Table/store/useTableStore";

import {
  VCS_AGENT_POOLS_TABLE_COLUMNS_CONFIG,
  VCS_AGENT_POOLS_TABLE_STORAGE_KEY,
} from "./constants";

const useVCSAgentPoolsTableStore = createTableStore({
  storageKey: VCS_AGENT_POOLS_TABLE_STORAGE_KEY,
  config: VCS_AGENT_POOLS_TABLE_COLUMNS_CONFIG,
});

export default useVCSAgentPoolsTableStore;
